"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FurtherQuestion = void 0;
/* eslint-disable react-hooks/exhaustive-deps */
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const FurtherQuestion_web_style_1 = require("./FurtherQuestion.web.style");
const FurtherQuestion_style_1 = require("./FurtherQuestion.style");
const GlobalStyles_1 = require("../../../../helper/GlobalStyles");
const atome_1 = require("../../../atome");
const organisms_1 = require("../../../organisms");
const User_service_1 = __importDefault(require("../../../../services/User.service"));
const hooks_1 = require("../../../../store/hooks");
const reducers_1 = require("../../../../store/reducers");
const enums_1 = require("../../../../enums");
const Breakpoints_1 = require("../../../../helper/Breakpoints");
const InputLoader_1 = __importDefault(require("../../../atome/InputLoader/InputLoader"));
const initialErrorState = {
    firstnameEmpty: false,
    lastnameEmpty: false,
    birthdayEmpty: false,
    genderEmpty: false,
    nationalityEmpty: false,
    preferredLanguageEmpty: false,
    insuranceEmpty: false,
    streetEmpty: false,
    houseNumberEmpty: false,
    zipEmpty: false,
    locationEmpty: false,
    countryEmpty: false,
};
// @ts-ignore
function FurtherQuestion({ navigation }) {
    // STATE MANAGEMENT
    const userInformation = (0, hooks_1.useAppSelector)(reducers_1.selectUserInformation);
    const dispatch = (0, hooks_1.useAppDispatch)();
    // FIELDS
    const [firstname, setFirstname] = (0, react_1.useState)('');
    const [lastname, setLastname] = (0, react_1.useState)('');
    const [birthDay, setBirthDay] = (0, react_1.useState)('');
    const [birthMonth, setBirthMonth] = (0, react_1.useState)('');
    const [birthYear, setBirthYear] = (0, react_1.useState)('');
    const [gender, setGender] = (0, react_1.useState)('');
    const [nationality, setNationality] = (0, react_1.useState)('');
    const [preferredLanguage, setPreferredLanguage] = (0, react_1.useState)('');
    const [insurance, setInsurance] = (0, react_1.useState)('');
    const [street, setStreet] = (0, react_1.useState)('');
    const [houseNumber, setHouseNumber] = (0, react_1.useState)('');
    const [zip, setZip] = (0, react_1.useState)('');
    const [location, setLocation] = (0, react_1.useState)('');
    const [country, setCountry] = (0, react_1.useState)('');
    const [addressId, setAddressId] = (0, react_1.useState)(-1);
    const [daysForWebPicker, setDaysForWebPicker] = (0, react_1.useState)([]);
    const [pickerItems, setPickerItems] = (0, react_1.useState)([]);
    // UTILITY
    const [saveSuccess, setSaveSuccess] = (0, react_1.useState)(false);
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [isSaving, setSaving] = (0, react_1.useState)(false);
    // VALIDATION
    const [error, setError] = (0, react_1.useState)(initialErrorState);
    const getUserInformation = async () => {
        const information = userInformation;
        (0, reducers_1.setUserInformation)(information);
        if (information.firstname !== undefined) {
            setFirstname(information.firstname);
        }
        if (information.lastname !== undefined) {
            setLastname(information.lastname);
        }
        if (information.birthday !== undefined) {
            setBirthDay(information.birthday.split('-')[2].replace('0', ''));
            setBirthMonth(information.birthday.split('-')[1].replace('0', ''));
            setBirthYear(information.birthday.split('-')[0]);
        }
        if (information.sex !== undefined) {
            setGender(information.sex);
        }
        if (information.nationality !== undefined) {
            setNationality(information.nationality);
        }
        if (information.language !== undefined) {
            setPreferredLanguage(information.language);
        }
        if (information.insurance !== undefined) {
            setInsurance(information.insurance);
        }
        // User can have many addresses but he will always have 0 or 1 at this point
        // so if he has we get the first one from the array
        if (information.address !== undefined && information.address.length > 0) {
            console.log('information.address', information.address);
            setAddressId(information.address[0].id);
            setStreet(information.address[0].street);
            setHouseNumber(information.address[0].houseNumber);
            setZip(information.address[0].postcode);
            setLocation(information.address[0].city);
            setCountry(information.address[0].country);
        }
    };
    // === HELPER FUNCTIONS START ===
    const onDOBPickerChange = (event) => {
        const { column, value } = event;
        const days = daysPerMonth[value];
        if (column === 'month') {
            const nPickerItems = pickerItems.slice();
            const newDays = {
                key: 'day',
                items: getDaysForDOB('', days),
            };
            nPickerItems.splice(0, 1, newDays);
            setPickerItems(nPickerItems);
        }
    };
    const onMonthChange = (value) => {
        const maxDays = daysPerMonth[value];
        const days = getDaysForDOB('', maxDays);
        if (parseInt(birthDay) > maxDays) {
            setBirthDay(maxDays.toString());
        }
        setDaysForWebPicker(days);
        setBirthMonth(value);
    };
    const daysPerMonth = (0, react_1.useMemo)(() => ({
        '1': 31,
        '2': 29,
        '3': 31,
        '4': 30,
        '5': 31,
        '6': 30,
        '7': 31,
        '8': 31,
        '9': 30,
        '10': 31,
        '11': 30,
        '12': 31,
    }), []);
    const getDaysForDOB = (extraLabelChar = '', maxDays = 31) => {
        let days = [];
        for (let i = 1; i <= maxDays; i++) {
            days.push({ label: i.toString() + extraLabelChar, value: i.toString() });
        }
        return days;
    };
    const getYearsForDOB = () => {
        const startYear = new Date().getFullYear();
        const endYear = startYear - 100;
        let years = [];
        for (let i = startYear; i >= endYear; i--) {
            years.push({ label: i.toString(), value: i.toString() });
        }
        return years;
    };
    // === HELPER FUNCTIONS END ===
    // === FUNCTIONALITY START ===
    const save = async () => {
        const newError = validate();
        if (Object.values(newError).find(e => e)) {
            return;
        }
        const data = {
            email: userInformation.email,
            isAlreadyCannabisPatient: userInformation.isAlreadyCannabisPatient,
            mobile: userInformation.mobile,
            firstname: firstname,
            lastname: lastname,
            birthday: `${birthYear}-${Number(birthMonth).toLocaleString('de-DE', {
                minimumIntegerDigits: 2,
            })}-${Number(birthDay).toLocaleString('de-DE', {
                minimumIntegerDigits: 2,
            })}`,
            sex: gender,
            nationality: nationality,
            language: preferredLanguage,
            insurance: insurance,
        };
        const addressData = {
            street: street,
            houseNumber: houseNumber,
            postcode: zip,
            city: location,
            country: country,
        };
        setSaving(true);
        // If the patient does not have an address yet we create one and give the id of the response to the addressData object
        // in order to store it in redux (userInformation)
        // If the patient has an address already we add the id in the addressData and only send it to the update function
        // and also update the userInformation with the address changes if there are any
        if (addressId === -1) {
            const responseAddress = await User_service_1.default.createPatientAddress(addressData);
            responseAddress.data[1] !== -1 &&
                (addressData.id = responseAddress.data[1]);
        }
        else {
            addressData.id = addressId;
            data.address = [addressData];
        }
        const response = await User_service_1.default.update(data);
        setSaving(false);
        if (response.error) {
            console.log(response.message);
        }
        if (!response.error) {
            const newUserInformation = { ...userInformation };
            newUserInformation.firstname = data.firstname;
            newUserInformation.lastname = data.lastname;
            newUserInformation.birthday = data.birthday;
            newUserInformation.insurance = data.insurance;
            newUserInformation.language = data.language;
            newUserInformation.nationality = data.nationality;
            newUserInformation.sex = data.sex;
            newUserInformation.address = [addressData];
            dispatch((0, reducers_1.setUserInformation)(newUserInformation));
            setSaveSuccess(true);
            setTimeout(() => {
                setSaveSuccess(false);
                navigation.navigate('CaseHistoryOverview');
            }, 2000);
        }
    };
    const validate = () => {
        const newError = {
            firstnameEmpty: firstname === '',
            lastnameEmpty: lastname === '',
            birthdayEmpty: birthDay === '' || birthMonth === '' || birthYear === '',
            genderEmpty: gender === '',
            nationalityEmpty: nationality === '',
            preferredLanguageEmpty: preferredLanguage === '',
            insuranceEmpty: insurance === '',
            streetEmpty: street === '',
            houseNumberEmpty: houseNumber === '',
            zipEmpty: zip === '',
            locationEmpty: location === '',
            countryEmpty: country === '',
        };
        setError(newError);
        return newError;
    };
    // === FUNCTIONALITY END ===
    // === STATE SECTION START ===
    (0, react_1.useEffect)(() => {
        setPickerItems([
            {
                key: 'day',
                items: getDaysForDOB(),
            },
            {
                key: 'month',
                items: [
                    { label: 'Januar', value: '1' },
                    { label: 'Februar', value: '2' },
                    { label: 'März', value: '3' },
                    { label: 'April', value: '4' },
                    { label: 'Mai', value: '5' },
                    { label: 'Juni', value: '6' },
                    { label: 'Juli', value: '7' },
                    { label: 'August', value: '8' },
                    { label: 'September', value: '9' },
                    { label: 'Oktober', value: '10' },
                    { label: 'November', value: '11' },
                    { label: 'Dezember', value: '12' },
                ],
            },
            {
                key: 'year',
                items: getYearsForDOB(),
            },
        ]);
        setDaysForWebPicker(getDaysForDOB());
        return navigation.addListener('focus', async () => {
            setLoading(true);
            if (userInformation.id) {
                await getUserInformation();
            }
            setLoading(false);
        });
    }, []);
    (0, react_1.useEffect)(() => {
        getUserInformation().then(() => { });
    }, [userInformation]);
    if (loading) {
        return react_1.default.createElement(atome_1.Loading, null);
    }
    // === STATE SECTION END ===
    return (react_1.default.createElement(atome_1.ProtectedPage, { navigation: navigation },
        react_1.default.createElement(react_native_1.SafeAreaView, null,
            react_1.default.createElement(react_native_1.ScrollView, { style: [!Breakpoints_1.isDesktop && FurtherQuestion_style_1.styles.scrollview] },
                react_1.default.createElement(organisms_1.UserHeader, { navigation: navigation }),
                react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isDesktop
                        ? FurtherQuestion_web_style_1.styles.container
                        : [FurtherQuestion_style_1.styles.containerMobileFromWeb] },
                    react_1.default.createElement(react_native_1.View, null,
                        react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.heading3] }, "Pers\u00F6nliche Angaben"),
                        react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                ? GlobalStyles_1.globalStyles.column
                                : [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginRow] },
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.firstnameEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : GlobalStyles_1.globalStyles.flex2 },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Vorname"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.firstnameEmpty, onChange: setFirstname, value: firstname, isEditable: !userInformation?.progress?.isDataConfirm, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined }),
                                react_1.default.createElement(react_native_1.View, null, error.firstnameEmpty && (react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.lastnameEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : GlobalStyles_1.globalStyles.flex2 },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Nachname"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.lastnameEmpty, onChange: setLastname, value: lastname, isEditable: !userInformation?.progress?.isDataConfirm, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined }),
                                react_1.default.createElement(react_native_1.View, null, error.lastnameEmpty && (react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD))))),
                        react_1.default.createElement(react_native_1.View, { style: [
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.row : GlobalStyles_1.globalStyles.column,
                                Breakpoints_1.isDesktop ? GlobalStyles_1.globalStyles.marginRow : null,
                            ] },
                            react_1.default.createElement(react_native_1.View, { style: [
                                    GlobalStyles_1.globalStyles.flex1,
                                    Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                        ? error.birthdayEmpty
                                            ? GlobalStyles_1.globalStyles.marginBottom30
                                            : GlobalStyles_1.globalStyles.marginBottom10
                                        : null,
                                ] },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Geburtsdatum"),
                                react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                        ? GlobalStyles_1.globalStyles.column
                                        : GlobalStyles_1.globalStyles.row },
                                    react_native_1.Platform.OS === 'web' && (react_1.default.createElement(react_1.default.Fragment, null,
                                        react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, hasError: error.birthdayEmpty, firstLabel: "Tag", value: birthDay, onChange: setBirthDay, disableFirstLabel: birthDay !== '', enabled: !userInformation?.progress?.isDataConfirm, items: daysForWebPicker }),
                                        react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, hasError: error.birthdayEmpty, firstLabel: "Monat", value: birthMonth, onChange: onMonthChange, disableFirstLabel: birthMonth !== '', enabled: !userInformation?.progress?.isDataConfirm, items: [
                                                { label: 'Januar', value: 1 },
                                                { label: 'Februar', value: 2 },
                                                { label: 'März', value: 3 },
                                                { label: 'April', value: 4 },
                                                { label: 'Mai', value: 5 },
                                                { label: 'Juni', value: 6 },
                                                { label: 'Juli', value: 7 },
                                                { label: 'August', value: 8 },
                                                { label: 'September', value: 9 },
                                                { label: 'Oktober', value: 10 },
                                                { label: 'November', value: 11 },
                                                { label: 'Dezember', value: 12 },
                                            ] }),
                                        react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, hasError: error.birthdayEmpty, firstLabel: "Jahr", value: birthYear, onChange: setBirthYear, disableFirstLabel: birthYear !== '', enabled: !userInformation?.progress?.isDataConfirm, items: getYearsForDOB() }))),
                                    react_native_1.Platform.OS !== 'web' && (react_1.default.createElement(atome_1.PickerFieldSegmented, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.picker] : undefined, currentValue: [birthDay, birthMonth, birthYear], setter: [setBirthDay, setBirthMonth, setBirthYear], hasError: error.birthdayEmpty, firstLabels: [''], seperator: ' ', enabled: !userInformation?.progress?.isDataConfirm, items: pickerItems, onValueChange: onDOBPickerChange }))),
                                react_1.default.createElement(react_native_1.View, null, error.birthdayEmpty && (react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.genderEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : GlobalStyles_1.globalStyles.flex1 },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Geschlecht"),
                                react_native_1.Platform.OS === 'web' && (react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, hasError: error.genderEmpty, value: gender, onChange: setGender, disableFirstLabel: gender !== '', enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        { label: 'männlich', value: 'male' },
                                        { label: 'weiblich', value: 'female' },
                                        { label: 'divers', value: 'other' },
                                    ] })),
                                react_native_1.Platform.OS !== 'web' && (react_1.default.createElement(atome_1.PickerFieldSegmented, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.picker] : undefined, currentValue: [gender], setter: [setGender], hasError: error.genderEmpty, firstLabels: [''], enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        {
                                            key: 'gender',
                                            items: [
                                                { label: 'männlich', value: 'male' },
                                                { label: 'weiblich', value: 'female' },
                                                { label: 'divers', value: 'other' },
                                            ],
                                        },
                                    ] })),
                                react_1.default.createElement(react_native_1.View, null, error.genderEmpty && (react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD))))),
                        react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                ? GlobalStyles_1.globalStyles.column
                                : [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginRow] },
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.nationalityEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : GlobalStyles_1.globalStyles.flex1 },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Nationalit\u00E4t"),
                                react_native_1.Platform.OS === 'web' && (react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, hasError: error.nationalityEmpty, onChange: setNationality, value: nationality, disableFirstLabel: nationality !== '', enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        { label: 'Deutsch', value: 'german' },
                                        { label: 'Österreichisch', value: 'austrian' },
                                        { label: 'Schweizerisch', value: 'swiss' },
                                        { label: 'Belgisch', value: 'belgian' },
                                        { label: 'Britisch', value: 'british' },
                                        { label: 'Dänisch', value: 'danish' },
                                        { label: 'Finnisch', value: 'finnish' },
                                        { label: 'Französisch', value: 'french' },
                                        { label: 'Griechisch', value: 'greek' },
                                        { label: 'Italienisch ', value: 'italian' },
                                        { label: 'Niederländisch', value: 'dutch' },
                                        { label: 'Norwegisch', value: 'norwegian' },
                                        { label: 'Polnisch', value: 'polish' },
                                        { label: 'Portugiesisch', value: 'portuguese' },
                                        { label: 'Schwedisch', value: 'swedish' },
                                        { label: 'Spanisch', value: 'spanish' },
                                        { label: 'Tschechisch', value: 'czech' },
                                        { label: 'Türkisch', value: 'turkish' },
                                        { label: 'US-amerikanisch', value: 'american' },
                                        { label: 'Andere', value: 'other' },
                                    ] })),
                                react_native_1.Platform.OS !== 'web' && (react_1.default.createElement(atome_1.PickerFieldSegmented, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.picker] : undefined, currentValue: [nationality], setter: [setNationality], hasError: error.nationalityEmpty, firstLabels: [''], enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        {
                                            key: 'nationality',
                                            items: [
                                                { label: 'Deutsch', value: 'german' },
                                                { label: 'Österreichisch', value: 'austrian' },
                                                { label: 'Schweizerisch', value: 'swiss' },
                                                { label: 'Belgisch', value: 'belgian' },
                                                { label: 'Britisch', value: 'british' },
                                                { label: 'Dänisch', value: 'danish' },
                                                { label: 'Finnisch', value: 'finnish' },
                                                { label: 'Französisch', value: 'french' },
                                                { label: 'Griechisch', value: 'greek' },
                                                { label: 'Italienisch ', value: 'italian' },
                                                { label: 'Niederländisch', value: 'dutch' },
                                                { label: 'Norwegisch', value: 'norwegian' },
                                                { label: 'Polnisch', value: 'polish' },
                                                { label: 'Portugiesisch', value: 'portuguese' },
                                                { label: 'Schwedisch', value: 'swedish' },
                                                { label: 'Spanisch', value: 'spanish' },
                                                { label: 'Tschechisch', value: 'czech' },
                                                { label: 'Türkisch', value: 'turkish' },
                                                { label: 'US-amerikanisch', value: 'american' },
                                                { label: 'Andere', value: 'other' },
                                            ],
                                        },
                                    ] })),
                                react_1.default.createElement(react_native_1.View, null, error.nationalityEmpty && (react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.preferredLanguageEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : GlobalStyles_1.globalStyles.flex1 },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Bevorzugte Sprache"),
                                react_native_1.Platform.OS === 'web' && (react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, hasError: error.preferredLanguageEmpty, onChange: setPreferredLanguage, value: preferredLanguage, disableFirstLabel: preferredLanguage !== '', enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        { label: 'Deutsch', value: 'german' },
                                        { label: 'Englisch', value: 'english' },
                                    ] })),
                                react_native_1.Platform.OS !== 'web' && (react_1.default.createElement(atome_1.PickerFieldSegmented, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.picker] : undefined, currentValue: [preferredLanguage], setter: [setPreferredLanguage], hasError: error.preferredLanguageEmpty, firstLabels: [''], enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        {
                                            key: 'preferredLanguage',
                                            items: [
                                                { label: 'Deutsch', value: 'german' },
                                                { label: 'Englisch', value: 'english' },
                                            ],
                                        },
                                    ] })),
                                react_1.default.createElement(react_native_1.View, null, error.preferredLanguageEmpty && (react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.insuranceEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : GlobalStyles_1.globalStyles.flex1 },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Versicherung"),
                                react_native_1.Platform.OS === 'web' && (react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, hasError: error.insuranceEmpty, onChange: setInsurance, value: insurance, disableFirstLabel: insurance !== '', enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        { label: 'privat', value: 'private' },
                                        { label: 'gesetzlich', value: 'statutory' },
                                        { label: 'keine', value: 'none' },
                                    ] })),
                                react_native_1.Platform.OS !== 'web' && (react_1.default.createElement(atome_1.PickerFieldSegmented, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.picker] : undefined, currentValue: [insurance], setter: [setInsurance], hasError: error.insuranceEmpty, firstLabels: [''], enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        {
                                            key: 'insurance',
                                            items: [
                                                { label: 'privat', value: 'private' },
                                                { label: 'gesetzlich', value: 'statutory' },
                                                { label: 'keine', value: 'none' },
                                            ],
                                        },
                                    ] })),
                                react_1.default.createElement(react_native_1.View, null, error.insuranceEmpty && (react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.errorText, GlobalStyles_1.globalStyles.marginTop5] }, enums_1.ErrorMessages.EMPTY_FIELD)))))),
                    react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? GlobalStyles_1.globalStyles.marginBottom20 : null },
                        react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.heading3] }, "Adresse"),
                        react_1.default.createElement(atome_1.Label, null, "Bitte geben Sie Ihre Meldeadresse unbedingt vollst\u00E4ndig und korrekt an."),
                        react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.introText] }, "Eine eventuell abweichende Anschrift k\u00F6nnen Sie uns zu einem sp\u00E4teren Zeitpunkt mitteilen."),
                        react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                ? GlobalStyles_1.globalStyles.column
                                : [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginRow] },
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.streetEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : null },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Stra\u00DFe"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.streetEmpty, onChange: setStreet, value: street, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, isEditable: !userInformation?.progress?.isDataConfirm }),
                                react_1.default.createElement(react_native_1.View, null, error.streetEmpty && (react_1.default.createElement(atome_1.Text, { style: [
                                        FurtherQuestion_web_style_1.styles.errorTextAddress,
                                        GlobalStyles_1.globalStyles.marginTop5,
                                    ] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.houseNumberEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : null },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Hausnummer"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.houseNumberEmpty, onChange: setHouseNumber, value: houseNumber, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, isEditable: !userInformation?.progress?.isDataConfirm }),
                                react_1.default.createElement(react_native_1.View, null, error.houseNumberEmpty && (react_1.default.createElement(atome_1.Text, { style: [
                                        FurtherQuestion_web_style_1.styles.errorTextAddress,
                                        GlobalStyles_1.globalStyles.marginTop5,
                                    ] }, enums_1.ErrorMessages.EMPTY_FIELD))))),
                        react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                ? GlobalStyles_1.globalStyles.column
                                : [GlobalStyles_1.globalStyles.row, GlobalStyles_1.globalStyles.marginRow] },
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.zipEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : null },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "PLZ"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.zipEmpty, onChange: setZip, value: zip, isNumber: true, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, isEditable: !userInformation?.progress?.isDataConfirm }),
                                react_1.default.createElement(react_native_1.View, null, error.zipEmpty && (react_1.default.createElement(atome_1.Text, { style: [
                                        FurtherQuestion_web_style_1.styles.errorTextAddress,
                                        GlobalStyles_1.globalStyles.marginTop5,
                                    ] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                    ? error.locationEmpty
                                        ? GlobalStyles_1.globalStyles.marginBottom30
                                        : GlobalStyles_1.globalStyles.marginBottom10
                                    : null },
                                react_1.default.createElement(atome_1.Label, { style: [FurtherQuestion_web_style_1.styles.label] }, "Ort"),
                                react_1.default.createElement(atome_1.InputField, { hasError: error.locationEmpty, onChange: setLocation, value: location, style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, isEditable: !userInformation?.progress?.isDataConfirm }),
                                react_1.default.createElement(react_native_1.View, null, error.locationEmpty && (react_1.default.createElement(atome_1.Text, { style: [
                                        FurtherQuestion_web_style_1.styles.errorTextAddress,
                                        GlobalStyles_1.globalStyles.marginTop5,
                                    ] }, enums_1.ErrorMessages.EMPTY_FIELD)))),
                            react_1.default.createElement(react_native_1.View, { style: [
                                    Breakpoints_1.isMobile || Breakpoints_1.isTablet
                                        ? error.countryEmpty
                                            ? GlobalStyles_1.globalStyles.marginBottom30
                                            : GlobalStyles_1.globalStyles.marginBottom10
                                        : null,
                                    { minWidth: 200 },
                                ] },
                                react_1.default.createElement(atome_1.Label, null, "Land"),
                                react_native_1.Platform.OS === 'web' && (react_1.default.createElement(atome_1.PickerField, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.input] : undefined, hasError: error.countryEmpty, onChange: setCountry, value: country, disableFirstLabel: country !== '', enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        { label: 'Deutschland', value: 'germany' },
                                        { label: 'Österreich', value: 'austria' },
                                        { label: 'Schweiz', value: 'switzerland' },
                                        { label: 'Belgien', value: 'belgium' },
                                        { label: 'Dänemark', value: 'denmark' },
                                        { label: 'Finnland', value: 'finland' },
                                        { label: 'Frankreich', value: 'france' },
                                        { label: 'Griechenland', value: 'greece' },
                                        { label: 'Italien', value: 'italy' },
                                        { label: 'Niederlande', value: 'netherlands' },
                                        { label: 'Norwegen', value: 'norway' },
                                        { label: 'Polen', value: 'poland' },
                                        { label: 'Portugal', value: 'portugal' },
                                        { label: 'Schweden', value: 'sweden' },
                                        { label: 'Spanien', value: 'spain' },
                                        { label: 'Tschechien', value: 'czechRepublic' },
                                        { label: 'Türkei', value: 'turkey' },
                                        { label: 'USA', value: 'unitedStates' },
                                        {
                                            label: 'Vereinigtes Königreich',
                                            value: 'unitedKingdom',
                                        },
                                    ] })),
                                react_native_1.Platform.OS !== 'web' && (react_1.default.createElement(atome_1.PickerFieldSegmented, { style: Breakpoints_1.isMobile || Breakpoints_1.isTablet ? [FurtherQuestion_web_style_1.styles.picker] : undefined, currentValue: [country], setter: [setCountry], hasError: error.countryEmpty, firstLabels: [''], enabled: !userInformation?.progress?.isDataConfirm, items: [
                                        {
                                            key: 'country',
                                            items: [
                                                { label: 'Deutschland', value: 'germany' },
                                                { label: 'Österreich', value: 'austria' },
                                                { label: 'Schweiz', value: 'switzerland' },
                                                { label: 'Belgien', value: 'belgium' },
                                                { label: 'Dänemark', value: 'denmark' },
                                                { label: 'Finnland', value: 'finland' },
                                                { label: 'Frankreich', value: 'france' },
                                                { label: 'Griechenland', value: 'greece' },
                                                { label: 'Italien', value: 'italy' },
                                                { label: 'Niederlande', value: 'netherlands' },
                                                { label: 'Norwegen', value: 'norway' },
                                                { label: 'Polen', value: 'poland' },
                                                { label: 'Portugal', value: 'portugal' },
                                                { label: 'Schweden', value: 'sweden' },
                                                { label: 'Spanien', value: 'spain' },
                                                { label: 'Tschechien', value: 'czechRepublic' },
                                                { label: 'Türkei', value: 'turkey' },
                                                { label: 'USA', value: 'unitedStates' },
                                                {
                                                    label: 'Vereinigtes Königreich',
                                                    value: 'unitedKingdom',
                                                },
                                            ],
                                        },
                                    ] })),
                                react_1.default.createElement(react_native_1.View, null, error.countryEmpty && (react_1.default.createElement(atome_1.Text, { style: [
                                        FurtherQuestion_web_style_1.styles.errorTextAddress,
                                        GlobalStyles_1.globalStyles.marginTop5,
                                    ] }, enums_1.ErrorMessages.EMPTY_FIELD)))))),
                    react_1.default.createElement(react_native_1.View, null,
                        saveSuccess && (react_1.default.createElement(react_native_1.View, { style: [GlobalStyles_1.globalStyles.row, FurtherQuestion_web_style_1.styles.saveMessageContainer] },
                            react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.saveMessageText] }, "Speichern erfolgreich"))),
                        !userInformation?.progress.isDataConfirm && (react_1.default.createElement(react_native_1.View, { style: [
                                GlobalStyles_1.globalStyles.row,
                                GlobalStyles_1.globalStyles.marginRow,
                                FurtherQuestion_web_style_1.styles.buttonContainer,
                            ] },
                            react_1.default.createElement(react_native_1.Pressable, { pointerEvents: isSaving ? 'none' : 'auto', style: [
                                    isSaving ? FurtherQuestion_web_style_1.styles.buttonLoading : FurtherQuestion_web_style_1.styles.button,
                                    GlobalStyles_1.globalStyles.saveButtonContainer,
                                ], onPress: save },
                                isSaving ? react_1.default.createElement(InputLoader_1.default, null) : null,
                                react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.buttonText] }, "Speichern")),
                            Object.values(error).find(e => e) && (react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.errorText] }, enums_1.ErrorMessages.ERROR)))),
                        react_1.default.createElement(react_native_1.View, { style: [
                                GlobalStyles_1.globalStyles.row,
                                GlobalStyles_1.globalStyles.marginRow,
                                FurtherQuestion_web_style_1.styles.buttonContainer,
                            ] },
                            react_1.default.createElement(react_native_1.Pressable, { onPress: () => navigation.navigate('CaseHistoryOverview') },
                                react_1.default.createElement(atome_1.Text, { style: [FurtherQuestion_web_style_1.styles.backButtonText] }, "\u2190 Zur\u00FCck")))))))));
}
exports.FurtherQuestion = FurtherQuestion;
